var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMesic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_2",
    "data-name": "Vrstva 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 153.56 158.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_1-2",
    "data-name": "Vrstva 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.49,117.11c25.94,5.03,36.57-7.42,40.07-4.34.77.67,1.33,3.36.78,4.32-6.79,11.75-15.23,22.96-27.34,29.9-25.04,14.37-56.08,15.95-82.3,3.54C18.44,138.57,2.79,114.04.33,86.54-3.54,43.14,26.65,5.92,69.68.04c1.26-.17,3.21.22,4.02.78s.5,3.63-.51,4.69c-17.44,18.29-23.92,47.93-12.35,71.83,10.07,20.79,29.06,35.39,51.65,39.77ZM142.87,121.87c-14.37,3.58-27.8,3.29-41.11-1.39-17.25-5.44-31.1-16.26-41.24-31.28-16.22-24.73-15.31-56.22,2.06-81.11C34.68,13.83,13.84,35.78,7.94,63.55c-6.58,30.99,6.17,62.5,33.34,78.89,31.08,18.18,80.98,12.75,101.59-20.57Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMesic);
export default __webpack_public_path__ + "static/media/mesic.f6f45940aa93af74ff6bfa3ae9526827.svg";
export { ForwardRef as ReactComponent };